import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Listbox, ListboxItem } from "@heroui/react";
import SearchboxInput from '../Searchbox-Input';
import { includes } from 'lodash';
import LoadingSpinner from '../../../../shared/components/loading-spinner/LoadingSpinner';

interface IFilterOwnershipSelectboxProps {
    options: string[];
    selectedKeys: string[];
    updateSelectedKeys: (keys: string[]) => void;
    emptyListMessage?: string;
    selectionMode?: 'single' | 'multiple';
    hideSelectedIcon?: boolean;
}

const OwnershipsSelectbox: React.FC<IFilterOwnershipSelectboxProps> = ({ ...props }) => {
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [filteredOptions, setFilteredOptions] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const msiOwnershipsOffsetRef = useRef(0);
    const itemsPerLoad = 100;
    // Filter items based on search term
    useEffect(() => {
        const filteredOptions = props.options.filter((item: string) =>
            item.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredOptions([...filteredOptions].slice(0, itemsPerLoad));
        setIsLoading(false);
        msiOwnershipsOffsetRef.current = itemsPerLoad;
    }, [searchTerm, props.options]);


    const getFilteredOwnerships = useCallback((searchTerm: string) => {
        return [...props.options].filter((item: string) =>
            item.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [props.options]);

    const loadMsiOwnershipsOnScroll = useCallback((listboxRef: any) => {

        const listbox = listboxRef.currentTarget;
        if (!listbox) return;

        const { scrollTop, scrollHeight, clientHeight } = listbox;

        // If user scrolls to the bottom and there are more items to load
        if (scrollTop + clientHeight >= scrollHeight && msiOwnershipsOffsetRef.current < getFilteredOwnerships(searchTerm).length) {
            const filteredLeftItems = getFilteredOwnerships(searchTerm);
            setFilteredOptions((prevItems) => [
                ...prevItems,
                ...filteredLeftItems.slice(msiOwnershipsOffsetRef.current, msiOwnershipsOffsetRef.current + itemsPerLoad)]);

            msiOwnershipsOffsetRef.current = msiOwnershipsOffsetRef.current + itemsPerLoad;
        }
    }, [getFilteredOwnerships, searchTerm])

    return (
        <>
            <SearchboxInput setSearchTerm={(searchTerm) => { setSearchTerm(searchTerm); setIsLoading(true); }} />
            {isLoading && filteredOptions.length === 0 ? <LoadingSpinner size='sm' label="Loading ownerships" spinnerClassName='flex-auto w-60' /> :
                <Listbox
                    aria-label="Listbox"
                    emptyContent={props.emptyListMessage ?? "No ownerships found"}
                    classNames={{
                        emptyContent: 'text-center',
                    }}
                    selectionMode={props.selectionMode}
                    hideSelectedIcon={props.hideSelectedIcon}
                    className="flex-auto overflow-y-auto border w-60"
                    onScroll={(ref) => { loadMsiOwnershipsOnScroll(ref) }} // To trigger scroll event 
                    style={{ scrollbarGutter: 'stable'}}                    
                    selectedKeys={props.selectedKeys}
                    onSelectionChange={(keys) => props.updateSelectedKeys(Array.from(keys, String))}
                >
                    {filteredOptions.map(item => (
                        <ListboxItem className={`rounded h-6 ${includes(Array.from(props.selectedKeys), item.toString()) ? 'bg-[#D4D4D8]' : null}`} key={item} textValue={item}>
                            {item}
                        </ListboxItem>
                    ))}
                </Listbox>
            }

        </>

    );
};

export default OwnershipsSelectbox;

